import Analytics from '@web-solutions/module-analytics';

/**
 * Quiz answers that SubTruck can pass to the Meta Conversions API as the `g`
 * (gender) and `db` (date of birth) user_data fields. Until now these reached
 * only our own backend, so the server-side events had no gender/birth date
 * to match on.
 *
 * The property names and value formats below follow Meta's own normalisation
 * rules (`m` / `f`, `YYYYMMDD`) and are PROVISIONAL: SubTruck has not yet
 * confirmed which user properties it reads. Rename here, in one place, once
 * they answer.
 */
export const GENDER_USER_PROPERTY = 'gender';
export const DATE_OF_BIRTH_USER_PROPERTY = 'date_of_birth';
export const BIRTH_YEAR_USER_PROPERTY = 'birth_year';

export function setGenderUserProperty(gender: string | undefined): void {
  const normalized = String(gender || '').trim().toLowerCase();

  const value = normalized === 'male' || normalized === 'm'
    ? 'm'
    : normalized === 'female' || normalized === 'f'
      ? 'f'
      : undefined;

  if (value) {
    Analytics.setUserProperty(GENDER_USER_PROPERTY, value);
  }
}

/** Full date from the birth-date picker → `YYYYMMDD`, plus the year on its own. */
export function setBirthDateUserProperty(birthDate: {
  year?: string | number;
  month?: string | number;
  day?: string | number;
} | undefined): void {
  if (!birthDate?.year || !birthDate?.month || !birthDate?.day) {
    return;
  }

  const year = String(birthDate.year).padStart(4, '0');
  const month = String(birthDate.month).padStart(2, '0');
  const day = String(birthDate.day).padStart(2, '0');

  Analytics.setUserProperty(DATE_OF_BIRTH_USER_PROPERTY, `${year}${month}${day}`);
  Analytics.setUserProperty(BIRTH_YEAR_USER_PROPERTY, year);
}

/**
 * The `born` screen asks for the age only, so the best we can derive is the
 * birth year (give or take one year, depending on whether the birthday has
 * already passed this year).
 */
export function setBirthYearFromAgeUserProperty(age: string | number | undefined): void {
  const ageNumber = Number(age);

  if (!ageNumber || ageNumber < 1 || ageNumber > 120) {
    return;
  }

  Analytics.setUserProperty(BIRTH_YEAR_USER_PROPERTY, String(new Date().getFullYear() - ageNumber));
}
